<template>
    <div>
        <!--Header Components-->
        <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <!-- <h6 class="h2 d-inline-block mb-0">{{$route.name}}</h6> -->
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                <route-breadcrumb/>
            </nav>
            </b-col>
            <!-- <b-col lg="6" cols="5" class="text-right">
            <base-button icon type="neutral" size="lg">
            <span class="btn-inner--icon"><i class="ni ni-fat-add"></i></span>
            <span class="btn-inner--text">New Customer</span>
            </base-button>
            </b-col> -->
        </b-row>
        </base-header>
        <div>
            <!-- <vue-element-loading :active="loading" :is-full-screen="true" color="#fb6340"/> -->
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6 container-padding">
            <b-row>
                <b-col lg="12">
                    <div class="card-wrapper">
                        <b-card no-body>
                            <b-tabs pills card>
                                <b-tab title="Non Fixed Income" v-if="show_tabs">
                                   <b-card-text>
                                        <card>
                                            <h3 slot="header">Non Fixed Income</h3>
                                            <b-row>
                                                <b-col cols="1">
                                                    <base-input label="Code" v-model="uom.code"></base-input>
                                                </b-col>
                                                <b-col cols="4">
                                                    <base-input label="Name" v-model="uom.multiplier" type="number"></base-input>
                                                </b-col>
                                                <b-col cols="2">
                                                    <base-input label="Account" v-model="uom.unit_price" type="number"></base-input>
                                                </b-col>
                                                <b-col cols="1">
                                                    <base-input label="Ord Wages (Y/N)" v-model="uom.unit_price" type="number"></base-input>
                                                </b-col>
                                                <b-col cols="1">
                                                    <base-input label="Add Wages (Y/N)" v-model="uom.unit_price" type="number"></base-input>
                                                </b-col>
                                                <b-col cols="1">
                                                    <base-input label="Non-Wage (Y/N)" v-model="uom.unit_price" type="number"></base-input>
                                                </b-col>
                                                <b-col cols="1">
                                                    <base-input label="CPF (Y/N)" v-model="uom.unit_price" type="number"></base-input>
                                                </b-col>
                                                
                                                <b-col lg="1" class='mt-4'>
                                                    <base-button  type="primary" class='mt-2' @click.native="addProductUom">
                                                        <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                                                    </base-button>
                                                 </b-col>
                                            </b-row>
                                            <b-row v-if="non_fixed_incomes.length > 0">
                                                <b-col lg="12">
                                                    <b-table-simple hover>
                                                        <b-thead head-variant="light">
                                                            <b-th>Code</b-th>
                                                            <b-th>Description</b-th>
                                                            <b-th>Account</b-th>
                                                            <b-th>Ord Wages</b-th>
                                                            <b-th>Additional Wages</b-th>
                                                            <b-th>Non-Wage Item</b-th>
                                                            <b-th>CPF Contribution</b-th>
                                                            <b-th></b-th>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <tr v-for="(item, j) in non_fixed_incomes" :key="j">
                                                                <td>{{item.code}}</td>
                                                                <td>{{item.name}}</td>
                                                                <td>{{item.account}}</td>
                                                                <td>{{item.ordinary_wages}}</td>
                                                                <td>{{item.additional_wages}}</td>
                                                                <td>{{item.non_wage_item}}</td>
                                                                <td>{{item.cpf}}</td>

                                                                <td>
                                                                    <base-button icon type="warning" @click="deleteUOM(item)" size="sm" :disabled="(item.is_default == 1)">
                                                                        <i class="fa fa-trash" aria-hidden="true" ></i>
                                                                    </base-button>
                                                                </td>
                                                            </tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </b-col>
                                            </b-row>
                                        </card>
                                   </b-card-text>
                                </b-tab>
                                <b-tab title="Deduction Fund Rates" v-if="show_tabs">
                                   <b-card-text>
                                        <card>
                                            <h3 slot="header">Deduction Fund Rates</h3>
                                            <b-row>
                                                <b-col cols="4">
                                                    <base-input label="Fund" v-model="uom.code"></base-input>
                                                </b-col>
                                                <b-col cols="2">
                                                    <base-input label="Effective From" v-model="uom.multiplier" type="number"></base-input>
                                                </b-col>
                                                <b-col cols="2">
                                                    <base-input label="Wage From ($)" v-model="uom.unit_price" type="number"></base-input>
                                                </b-col>
                                                <b-col cols="2">
                                                    <base-input label="Wage To ($)" v-model="uom.unit_price" type="number"></base-input>
                                                </b-col>
                                                <b-col cols="1">
                                                    <base-input label="Rate (%)" v-model="uom.unit_price" type="number"></base-input>
                                                </b-col>
                                                
                                                <b-col lg="1" class='mt-4'>
                                                    <base-button  type="primary" class='mt-2' @click.native="addProductUom">
                                                        <span class="btn-inner--text">{{language_terms['ADD']}}</span>
                                                    </base-button>
                                                 </b-col>
                                            </b-row>
                                            <b-row v-if="non_fixed_incomes.length > 0">
                                                <b-col lg="12">
                                                    <b-table-simple hover>
                                                        <b-thead head-variant="light">
                                                            <b-th>Fund</b-th>
                                                            <b-th>Effective Date</b-th>
                                                            <b-th>Wage From</b-th>
                                                            <b-th>Wage To</b-th>
                                                            <b-th>Rate</b-th>
                                                            <b-th></b-th>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <tr v-for="(item, j) in deduction_fund_rates" :key="j">
                                                                <td>{{item.code}}</td>
                                                                <td>{{item.date}}</td>
                                                                <td>{{item.wf}}</td>
                                                                <td>{{item.wt}}</td>
                                                                <td>{{item.rate}}</td>
                                                                <td>
                                                                    <base-button icon type="warning" @click="deleteUOM(item)" size="sm" :disabled="(item.is_default == 1)">
                                                                        <i class="fa fa-trash" aria-hidden="true" ></i>
                                                                    </base-button>
                                                                </td>
                                                            </tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </b-col>
                                            </b-row>
                                        </card>
                                   </b-card-text>
                                </b-tab>
                                <b-tab title="Payroll Batch Run" v-if="show_tabs">
                                   <b-card-text>
                                        <card>
                                            <h3 slot="header">Batch Run</h3>
                                            <b-row>
                                                <b-col cols="4">
                                                    <base-input label="Period (YYYYMM)" v-model="uom.code"></base-input>
                                                </b-col>
                                                
                                                <b-col lg="1" class='mt-4'>
                                                    <base-button  type="primary" class='mt-2' :disabled = "uom.code == ''" @click.native="onClickBatchRun">
                                                        <span class="btn-inner--text">Run</span>
                                                    </base-button>
                                                 </b-col>
                                            </b-row>
                                            <b-row v-if="payrolls.length > 0">
                                                <b-col lg="12">
                                                    <b-table-simple hover>
                                                        <b-thead head-variant="light">
                                                            <b-th>Period</b-th>
                                                            <b-th>Payslip Count</b-th>
                                                            <b-th>Ordinary Wage</b-th>
                                                            <b-th>CPF Contributions</b-th>
                                                            <b-th>Deductibles</b-th>
                                                            <b-th></b-th>
                                                        </b-thead>
                                                        <b-tbody>
                                                            <tr v-for="(item, j) in deduction_fund_rates" :key="j">
                                                                <td>{{item.code}}</td>
                                                                <td>{{item.date}}</td>
                                                                <td>{{item.wf}}</td>
                                                                <td>{{item.wt}}</td>
                                                                <td>{{item.rate}}</td>
                                                                <td>
                                                                    <base-button icon type="warning" @click="deleteUOM(item)" size="sm" :disabled="(item.is_default == 1)">
                                                                        <i class="fa fa-trash" aria-hidden="true" ></i>
                                                                    </base-button>
                                                                </td>
                                                            </tr>
                                                        </b-tbody>
                                                    </b-table-simple>
                                                </b-col>
                                            </b-row>
                                        </card>
                                   </b-card-text>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                        <b-row>
                            <b-col md="12">
                                <!-- <base-button icon type="primary"
                                    @click="saveProduct">
                                    <span class="btn-inner--text">{{language_terms['SAVE']}}</span>
                                </base-button> -->
                                <!-- <base-button icon type="danger"
                                    @click="deleteProduct">
                                    <span class="btn-inner--text">{{language_terms['DELETE']}}</span>
                                </base-button> -->
                                <!-- <base-button icon type="warning" @click="cancelProduct">
                                    <span class="btn-inner--text">{{language_terms['CANCEL']}}</span>
                                </base-button> -->
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>
        </b-container>
        <b-modal v-model="add_bom_product_modal" :header-bg-variant="'primary'"  size="lg" centered class="my-modal" >
            <template #modal-title>
                <span style="color: white">{{language_terms['ADD_PRODUCT']}}</span>
            </template>
            <b-row>
                <b-col sm="12">
                    <label class="form-control-label">{{language_terms['PRODUCT']}}</label>
                    <productLookup v-bind:url="apiProductLookup" v-on:selected="selectProduct($event)" :lookupId="bom.product_code" :v2="product.id" :disabled="isLocked"/>
                </b-col>
                <b-col sm="3">
                    <base-input :label="language_terms['QTY']" v-model="bom.qty" type="number" :min="0" :disabled="isLocked"></base-input>
                </b-col>
                <b-col sm="3">
                    <base-input :label="language_terms['UOM']" >
                        <el-select v-model="bom.uom" filterable :disabled="isLocked">
                            <el-option v-for="option in uom_list"
                                    :key="option.code"
                                    :label="option.code"
                                    :value="option.code">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
                <b-col sm="3">
                    <base-input :label="language_terms['PRICE_ADJUSTMENT']" v-model="bom.price_adjustment" type="number" :disabled="isLocked"></base-input>
                </b-col>
                <b-col sm="3">
                    <base-input :label="language_terms['IS_DEFAULT']" >
                        <el-select v-model="bom.is_default" filterable :disabled="isLocked">
                            <el-option v-for="option in is_default_options"
                                    :key="option.code"
                                    :label="option.label"
                                    :value="option.code">
                            </el-option>
                        </el-select>
                    </base-input>
                </b-col>
            </b-row>
                <template #modal-footer="{ ok, cancel }">
                <!-- Emulate built in modal footer ok and cancel button actions -->
                <b-button variant="primary" @click="addBomItemToGroup()">
                    {{language_terms['ADD']}}
                </b-button>
                <b-button variant="danger" @click="cancelAddBomModal()">
                    {{language_terms['CANCEL']}}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
import Vue from 'vue';
import { mapState } from "vuex";
import { Select, Option } from 'element-ui'
import HtmlEditor from '@/components/Inputs/HtmlEditor'
import VueBarcode from 'vue-barcode'
import VueQRCodeComponent from 'vue-qrcode-component'
import BaseButton from '../../components/BaseButton.vue';

import {apiRoutes} from "../../apiRoutes"
import { authHeader } from '../../global';
import Dropzone from "vue2-dropzone";
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import axios from 'axios'

import productLookup from "@/components/Autocomplete.vue";


import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 

import { VueEditor } from "vue2-editor";

export default {
  name:'Product-Details',
  data(){
      return{
        payrolls:[],
        deduction_fund_rates:[
        {"code":"CDAC", "date":"2015-04-01","wf":"0.00", "wt":"2000.00", "rate":"0.00"},
        {"code":"CDAC", "date":"2015-04-01","wf":"2000.01", "wt":"3500.00", "rate":"1.00"},
        {"code":"CDAC", "date":"2015-04-01","wf":"2000.01", "wt":"3500.00", "rate":"1.50"},
        {"code":"CDAC", "date":"2015-04-01","wf":"2000.01", "wt":"3500.00", "rate":"2.00"},
        {"code":"CDAC", "date":"2015-04-01","wf":"2000.01", "wt":"3500.00", "rate":"3.00"},

        {"code":"MBMF", "date":"2016-06-01","wf":"0.00", "wt":"1000.99", "rate":"3.00"},
        {"code":"MBMF", "date":"2016-06-01","wf":"1001.00", "wt":"2000.99", "rate":"4.50"},
        {"code":"MBMF", "date":"2016-06-01","wf":"2001.00", "wt":"3000.99", "rate":"6.50"},
        {"code":"MBMF", "date":"2016-06-01","wf":"3001.00", "wt":"4000.99", "rate":"15.00"},
        {"code":"MBMF", "date":"2016-06-01","wf":"4001.00", "wt":"6000.99", "rate":"19.50"},
        {"code":"MBMF", "date":"2016-06-01","wf":"6001.00", "wt":"8000.99", "rate":"22.00"},

        ],

        non_fixed_incomes:[
        {"name":"13 Months Bonuse", "code":"13MB", "account":"402450 - Staff Costs","ordinary_wages":"Y","additional_wages":"N","non_wage_item":"N","cpf":"Y"},
        {"name":"AWS", "code":"AWS", "account":"402450 - Staff Costs","ordinary_wages":"Y","additional_wages":"N","non_wage_item":"N","cpf":"Y"},
        {"name":"Variable Bonus", "code":"VB", "account":"402450 - Staff Costs","ordinary_wages":"Y","additional_wages":"N","non_wage_item":"N","cpf":"Y"},
        {"name":"Overtime pay", "code":"OT", "account":"402450 - Staff Costs","ordinary_wages":"Y","additional_wages":"N","non_wage_item":"N","cpf":"Y"},
        {"name":"Incentives", "code":"INC", "account":"402450 - Staff Costs","ordinary_wages":"Y","additional_wages":"N","non_wage_item":"N","cpf":"Y"},
        {"name":"Sales Commission", "code":"SC", "account":"400160 - Sales Commission","ordinary_wages":"Y","additional_wages":"N","non_wage_item":"N","cpf":"Y"},

        ],
        tax_codes:[
        {code: 'S', name:'Standard Rated'},
        {code: 'Z', name:'Zero Rated'},            
        ],
        account_options:[],
        add_bom_product_modal:false,
        selected_group_index:-1,
        show_add_group:false,
        customToolbar: [
            [{ header: [false, 1, 2, 3, 4, 5, 6] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            ["bold", "italic", "underline", "strike"],
            [
                { align: "" },
                { align: "center" },
                { align: "right" },
                { align: "justify" }
            ],
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            ["image", "blockquote", "link", "clean"]
        ],
        bom_configurable_options:[
            {code:"1", name :"CONFIGURABLE"},
            {code:"0", name :"FIXED"} 
        ],
        is_default_options:[
            {code:1, label :"YES"},
            {code:0, label :"NO"}
        ],
        bomTabelFields: [
            { key: 'index', label: 'SNO' },
            { key: 'product_code', label: 'PRODUCT_CODE' },
            { key: 'product_name', label: 'PRODUCT_NAME' },
            { key: 'qty', label: 'QTY' },
            { key: 'uom_code', label: 'UOB_CODE' },
            { key: 'price_adjustment', label: 'PRICE_ADJUSTMENT' },
            { key: 'is_default', label: 'IS_DEFAULT' },
            { key: 'deleteBtn', label: 'ACTION' },
        ],
        apiProductLookup: apiRoutes["LOOKUP_PRODUCT_FOR_BOM"],
        bom:{
            max_selection_count:1,
            price_adjustment:null,
            group_no:"",
            group_name:"",
            uom:"",
            uom_code:"",
            qty:null,
            product_id:'',
            product_code:'',
            is_default:1
        },
        dropzoneOptions: 
        {
            maxFiles: 1,
            url: "https://httpbin.org/post",
            thumbnailWidth: 200,
            addRemoveLinks: false,
            maxFilesize: 20,
                headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json',
                'Authorization': 'Bearer '+ localStorage.access_token
                }
        },
        isLocked:true,
        isShowBtn:false,
        loading:false,
        size:150,
        show_tabs:true,
        uom:{
            code:"",
            multiplier:null,
            unit_price:null
        },
        product_code:{
            code:"",
            type:"barcode_code128",
            tag:""
        },
        code_types:[
            {code:'barcode_upc', name:'BARCODE_UPC'},
            {code:'barcode_code128', name:'BARCODE_CODE_128'},
            {code:'qrcode', name:'QRCODE'}
        ],
        product:{
            sale_tax_code:'S',
            purchase_tax_code:'S',
            sale_account_code:null,
            purchase_account_code:null,
            inventory_account_code:null,
            languages:[],
            code:"",
            name:"",
            has_lot:0,
            is_trade:0,
            has_expiry:0,
            has_warranty:0,
            is_trade:0,
            warranty_mths:null,
            expiry_mths:null,
            reservation_max_days:null,
            is_sold:1,
            is_purchased:1,
            is_inventorized:1,
            base_uom:"",
            desp:"",
            desp_long:"",
            brand:"",
            model:"",
            sale_list_price:null,
            moq:"",
            is_active:1,
            is_bom_configurable:"0",
            sales_quotation_validity_days:null,
            category_items:[],
            product_codes:[],
            product_medias:[],
            product_boms:[],
            product_uoms:[],
            currency_code:"",
          },
            options_code_128: {
                format: "CODE128",
                lineColor: '#ff7069',
                fontSize: 32,
                font: 'Courier',
                width: 3,
                height: 30,
                marginBottom: 60,
                background: '#ccffff'
            },
            options_upc: {
                format: "upc",
                lineColor: '#ff7069',
                fontSize: 32,
                font: 'Courier',
                width: 3,
                height: 30,
                marginBottom: 60,
                background: '#ccffff'
            },
      }
  },
  components:
  {
    VueEditor,
    productLookup,
    Loading,
    Dropzone,
    // VueElementLoading,
    HtmlEditor,
    [Select.name]: Select,
    [Option.name]: Option,
    'barcode':VueBarcode,
    'qr-code':VueQRCodeComponent,
    BaseButton
  },
  computed:{
      ...mapState({
        default_sq_validity_days: state => state.sales.default_sq_validity_days,
        storage_classifications: state => state.storageclassifications.storage_classifications,
        product_filter: state =>  state.products.filter,
        product_is_created: state => state.products.is_created,
        product_is_updated: state => state.products.is_updated,
        product_is_deleted: state => state.products.is_deleted,
        is_bom_created: state => state.productBom.is_created,
        is_bom_deleted:state => state.productBom.is_deleted,
        uom_list:state => state.products.uom_list, 
        currencies: state => state.currencies.currencies,
        taxes: state => state.taxes.taxes,
        countries: state => state.countries.countries,
        product_data: state => state.products.product_data,
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
        product_categories: state => state.products.product_categories,
        product_media_is_updated: state => state.productMedias.is_updated,
        product_media_is_deleted: state => state.productMedias.is_deleted,
        active_languages:state => state.languages.active_languages,
        default_uom:state => state.products.default_uom

      }),
  },
  async mounted()
  {
    this.loading=true
    // this.loadDefaults()

    this.show_tabs = true
    this.loading = false

  },
  watch:{
        language_terms: {
            handler(val){
                this.updateBomFiledTerms()
            },
            deep: true
        }
  },
  methods:
  {
    async onClickBatchRun()
    {
        const url = 'https://api.unityerp.com/esteam-payslip-2301.xlsx'; // Replace 'your_file_url_here' with the actual URL of the file you want to download
      axios({
        url,
        method: 'GET',
        responseType: 'blob', // Important
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'payslip-2301.xlsx'); // Replace 'file_name.ext' with the desired file name and extension
        document.body.appendChild(link);
        link.click();
      });
    },
    async loadAccounts()
    {
        let payload = []
        await axios
        .post(apiRoutes["GET_ACCOUNTS_FOR_FY"], payload, authHeader())
        .then((response) => 
        {
            if (response.data.code == 1) {
                this.account_options = response.data.data
            } 
            else 
                Vue.notify({group: "notify", type: "error", text: response.data.msg, max: 5, duration: 5000, speed: 300,});
        })
        .catch((error) => {
            if (error.response) {
                Vue.notify({group: "notify", type: "error", text: error.response.data.msg, max: 5, duration: 5000, speed: 300,});
            }
        });
    },
    async loadDefaults()
    {
        await this.loadCurrencies()
        await this.loadCategories()
        await this.loadAccounts()
        await this.$store.dispatch('storageclassifications/fetchAll', {})
        await this.$store.dispatch("languages/fetchActiveLanguages", {})
        await this.$store.dispatch("products/getDefaultUOM", {})
    },
    clickOnIsDefaultbox(group_index, bom_item_index)
    {
        let count = this.hasDefaultCount(this.product.product_boms[group_index].boms);
        let max_selection_count = this.product.product_boms[group_index].max_selection_count

        if(this.product.product_boms[group_index].boms[bom_item_index].is_default == '1')
        {
           if(count <= max_selection_count)
           {
               this.product.product_boms[group_index].boms[bom_item_index].is_default = 1
           }
           else
           {
               this.product.product_boms[group_index].boms[bom_item_index].is_default = 0
           }
        }

    },
    cancelAddBomModal()
    {
        this.add_bom_product_modal = false
    },
    performAddProductToGroup(group_index)
    {
        this.selected_group_index = group_index
        this.add_bom_product_modal = true
    },
    setDefault(row, bom_index, group_index)
    {

        let bom_items = this.product.product_boms[group_index].boms
        //console.log(bom_items)

        for(let i = 0; i < bom_items.length; i++)
        {
            this.product.product_boms[group_index].boms[i].is_default = '0'
        }

        this.product.product_boms[group_index].boms[bom_index].is_default = '1'
        
    },
    addBomGroup()
    {
        this.bom.group_no = (this.product.product_boms.length * 1) + 1;

        if(this.bom.group_name == '' || this.bom.group_name == null)
        {
            alert("Please enter a group name!");
        }
        else
        {
            if(this.bom.max_selection_count == '' || this.bom.max_selection_count == null)
            {
                alert("Please enter max selection count!");
            }
            else
            {
                if(this.bom.group_name != '' && this.isFoundInList(this.bom.group_name) == 0)
                {
                    this.product.product_boms.push(
                        {
                            group_no:this.bom.group_no, 
                            group_name:this.bom.group_name, 
                            max_selection_count:this.bom.max_selection_count,
                            boms:[],
                            is_collapsed:true
                        })
                    this.bom.group_no = ""
                }
                else
                {
                    alert("The group number already exist!");
                }
            }

        }

    },
 
    onChangeBomProperty(selectedVal)
    {
        if(this.product.is_bom_configurable == 1)
        {
            this.show_add_group = true
        }
        else
        {
            this.show_add_group = false
        }

        this.product.product_boms = []
    },
    handleCollaspeBomGroup(index, row)
    {
        if(row.is_collapsed)
        {
           row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }

        this.$set(this.product.product_boms, index , row) 

    },
    async deleteBomGroup(index) 
    {
      if (index != -1) 
      {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
                  confirmButtonText: this.language_terms['YES'],
                  cancelButtonText: this.language_terms['CANCEL'],
                  type: 'warning'
                }).catch(() => {
              this.$message.info(this.language_terms['ACTION_CANCEL'])
             })
        if (response === 'confirm') {
             this.loading =true
             this.product.product_boms.splice(index, 1)
             this.loading =false
        }
      }
    },
    handleCollaspe(index, row)
    {
        if(row.is_collapsed)
        {
           row.is_collapsed = false
        }
        else
        {
          row.is_collapsed = true
        }

        this.$set(this.product.languages, index , row) 
    },
    updateBomFiledTerms()
    {
        for(let i = 0; i< this.bomTabelFields.length; i++)
        {
            this.bomTabelFields[i].label = this.language_terms[this.bomTabelFields[i].label]
        }
    },
    async deleteMedia(option)
    {
      if (option.id) 
      {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRM'], {    
            confirmButtonText: this.language_terms['YES'],
            cancelButtonText: this.language_terms['NO'],
            type: 'warning'
        }).catch(() => 
        {
          this.$message.info(this.language_terms['ACTION_CANCEL'])
        })
        if (response === 'confirm') 
        {
            this.loading =true
            await this.$store.dispatch("productMedias/delete", {id:option.id})
            if(this.product_media_is_deleted)
            {
                await this.retrieveProduct(this.product.code)
                this.product = this.product_data
            }
            this.loading =false
        }
      }
    },
    async deleteBom(row)
    {
        if(row)
        {   
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
                confirmButtonText: this.language_terms['YES'],
                cancelButtonText: this.language_terms['CANCEL'],
                type: 'warning'
            }).catch(() => {
                this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') 
            {
                this.loading = true
                let payload = {id:row.id, parent_product_id:row.parent_product_id}
                await this.$store.dispatch("productBom/delete", payload)
                if(this.is_bom_deleted)
                {
                    await this.retrieveProduct(this.product.code)
                    this.product = this.product_data
                }
                this.loading = false
            }
        }

    },
    async selectProduct(obj)
    {
        if(obj)
        {
            this.bom.product_id = obj.id
            this.bom.product_code = obj.code
            this.bom.product_name = obj.name

            await this.$store.dispatch("products/listUoms", {product_id:obj.id})


            if(this.uom_list.length > 0)
            {
                this.bom.uom = this.uom_list[0]
            }
        }
    },
    removeBomItemFromGroup(bom_item_index, group_index)
    {
        this.product.product_boms[group_index].boms.splice(bom_item_index, 1)    
    },
    hasDefaultCount(items)
    {
        let count = 0;

        for(let x = 0; x < items.length; x++)
        {
            if(items[x].is_default == '1')
            {
                count++;
            }
        }

        return count
    },
    addBomItemToGroup()
    {
        let index = this.selected_group_index
        
        if(index != -1)
        {
            let isValid = 1;
            let max_selection_count = (this.product.product_boms[index].max_selection_count) * 1
            let count = this.hasDefaultCount(this.product.product_boms[index].boms) * 1

            if(count >= max_selection_count)
            {
                if(this.bom.is_default == 1)
                {
                    isValid = 0;
                }
            }

            if(isValid == 1)
            {
                console.log("A")
                this.bom.uom_code = this.bom.uom.code
                if(this.bom.product_id && this.bom.qty && this.bom.uom_code)
                {
                    this.product.product_boms[index].boms.push(this.bom)
                    this.bom = {
                        uom:"",
                        uom_code:"",
                        qty:null,
                        product_id:'',
                        product_code:'',
                        is_default:0
                    }
                }
                this.add_bom_product_modal = false
            }
            else
            {
                alert("Default product counts must be <= Max Selection!");
            }

        }

    },
    async addBom()
    {
        this.bom.uom_code = this.bom.uom.code
        if(this.bom.product_id && this.bom.qty && this.bom.uom_code)
        {

            this.product.product_boms.push(this.bom)

            let is_default = 0;
            if(this.product.is_bom_configurable == '0')
            {
                is_default = 1;
            }

            this.bom = {
                uom:"",
                group_code:"",
                group_name:"",
                uom_code:"",
                qty:null,
                product_id:'',
                product_code:'',
                is_default:is_default
            }
        }
        
    },
    isFoundInList(group_name)
    {
        let is_found = 0
        for(let i = 0; i < this.product.product_boms.length; i++)
        {
            if(this.product.product_boms[i].group_name == group_name)
            {
              is_found = 1
            }
        }
        return is_found;
    },
    async removeBom(index)
    {
        let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
        confirmButtonText: this.language_terms['YES'],
        cancelButtonText: this.language_terms['CANCEL'],
        type: 'warning'
        }).catch(() => {
          this.$message.info(this.language_terms['ACTION_CANCEL'])
        })
        if (response === 'confirm') {
             this.loading = true
             this.product.product_boms.splice(index, 1)    
             this.loading = false
        }
 
    },
    async createBom()
    {
        this.bom.parent_product_id = this.product.id
        this.bom.uom_code = this.bom.uom.code
        await this.$store.dispatch("productBom/create", this.bom)

        if(this.is_bom_created)
        {
            await this.retrieveProduct(this.product.code)
            this.product = this.product_data

            this.bom = {
                uom:"",
                uom_code:"",
                qty:null,
                product_id:'',
                product_code:'',
                is_default:0
            }
        }
    },
    async sendingImage (file, xhr, formData) {
            let product_id = this.product.id
            await axios.post(apiRoutes['PRODUCT_MEDIA_UPLOAD'], formData, authHeader()).then (res =>{
                if (res.data.code == 1)
                {
                    // console.log(res.data.data)
                    let upload_id = res.data.data.upload_id
                    let payload = {upload_id:upload_id, product_id}

                    this.$store.dispatch("productMedias/update", payload)

                    console.log("BB")
                     // Push image to array
                    let media = {
                         id:upload_id,
                         product_id:product_id,
                         url:res.data.data.url,
                         file_alias:res.data.data.file_alias,
                         file_name:res.data.data.file_name,
                         file_extension:res.data.data.file_extension
                     }
                     this.product.product_medias.push(media);

                    this.$refs.myVueDropzone.removeFile(file)


                }
                else 
                {
                    this.alertMessage = res.data.msg
                    this.alertModal = true
                }
            })
            .catch(error => alert("Error: " + error))
        },
        removeImage(file)
        { 
         console.log(file) 
        },
      showFloatBtn(){
          this.isShowBtn = true
          this.isLocked = false


      },
     async deleteUOM(item)
    {
        if(item.id)
        {
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
            confirmButtonText: this.language_terms['YES'],
            cancelButtonText: this.language_terms['CANCEL'],
            type: 'warning'
            }).catch(() => {
            this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') 
            {
                this.loading = true
                await this.$store.dispatch("productUoms/delete", item)
                await this.retrieveProduct(this.product.code)
                this.product = this.product_data
                this.loading = false
            }
        }
    },
      async deleteCode(code){
        if(code.id)
        {
            let response = await this.$confirm(this.language_terms['ARE_YOU_SURE?'], this.language_terms['CONFIRMATION'], {
            confirmButtonText: this.language_terms['YES'],
            cancelButtonText: this.language_terms['CANCEL'],
            type: 'warning'
            }).catch(() => {
            this.$message.info(this.language_terms['ACTION_CANCEL'])
            })
            if (response === 'confirm') {
                this.loading = true
                await this.$store.dispatch("productCodes/delete", code)
                await this.retrieveProduct(this.product.code)
                this.product = this.product_data
                this.loading = false
            }
            
        }
           
      },
    async addProductUom()
    {
        if(this.uom.code && this.uom.multiplier)
        {
            this.uom.product_id = this.product.id
            console.log(this.product_code)

            await this.$store.dispatch("productUoms/create", this.uom)
           
            await this.retrieveProduct(this.product.code)
            this.product = this.product_data

            this.uom = {code:"",multiplier:null,unit_price:null}
        }
    },
    async addProductCode()
    {
        if(this.product_code.type && this.product_code.code)
        {
            // Create Product Code
            this.product_code.product_id = this.product.id
            console.log(this.product_code)
            await this.$store.dispatch("productCodes/create", this.product_code)
           
            await this.retrieveProduct(this.product.code)
            this.product = this.product_data

            this.product_code = {code:"",type:"barcode_code128",tag:""}

        }
        else
        {
            Vue.notify({
              group: "notify",
              type: "error",
              text: this.language_terms['ERROR_MSG_ADD_PRODUCT_CODE'],
              max: 5,
              duration: 5000,
              speed: 300,
            });
        }
    },
    async retrieveProduct(code)
    {
        this.loading=true
        await this.$store.dispatch("products/fetch", {
          code:code
        });
        this.loading=false
        //this.product = this.product_data
    },
    loadCategories(){
        this.loading=true
        this.$store.dispatch("products/fetchAllCategories", {})
        this.loading=false
    },
    loadCurrencies(){
        this.loading=true
        this.$store.dispatch("currencies/fetchAll", {});
        this.loading=false
    },
    async searchProducts()
    {
        this.loading = true
        let filter = {keyword:"",active_only:"1"}
        if(this.product_filter)
        {
            filter = this.product_filter
        }
        await this.$store.dispatch('products/quickSearch', filter)

        this.loading = false
    },
    async saveProduct()
    {
      this.loading=true
      if(this.$route.params.id == '_new')
      {
        await this.$store.dispatch("products/create", this.product);
        if(this.product_is_created)
        {
            await this.searchProducts()
            this.$router.push("/products/master")
        }
      }
      else
      {
        await this.$store.dispatch("products/update", this.product);
        if(this.product_is_updated)
        {
            await this.searchProducts()
            this.$router.push("/products/master")
        }
      }
      this.loading=false
    },
    async deleteProduct(){
       // alert("delete")
        await this.$store.dispatch("products/delete", {id:this.product.id});
        if(this.product_is_deleted)
        {
            await this.searchProducts()
            this.$router.push("/products/master")
        }
     

    },
    cancelProduct(){
            if(this.$route.params.id == '_new')
            {
                this.$router.push("/users/master")
            }
            else
            {
                location.reload();
            }    }
  }
}
</script>
<style lang="scss">
.container {
  position: relative;
}

.image {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: .5s ease;
  backface-visibility: hidden;
}

.middle {
  transition: .5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.container:hover .image {
  opacity: 0.3;
}
.container:hover .middle {
  opacity: 1;
}


</style>